import React, { useEffect, useState } from "react";
// @material-ui/core components
import {
  Box,
  Button,
  Dialog,
  Fab,
  IconButton,
  makeStyles,
  Slide,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  useTheme,
} from "@material-ui/core";
// core components
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import CustomInput from "../../components/CustomInput/CustomInput.js";
import Card from "../../components/Card/Card.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";
import {
  CreateChallanAPI,
  GetAllAccountsAPI,
  GetAccountAPI,
  GetAllFittingMastersAPI,
  GetAllOrdersAPI,
  GetAllPrintAdsAPI,
  GetAllReadyMastersAPI,
  GetAllReadyMastersCodesAPI,
  GetEntityAPI,
  UpdateOrderAPI,
} from "../../config/api";
import axios from "axios";
import Autocomplete from "@material-ui/lab/Autocomplete";
import AddIcon from "@material-ui/icons/Add";
import _ from "lodash";
import DeleteIcon from "@material-ui/icons/Delete";
import { useSelector } from "react-redux";
import { createFilterOptions } from "@material-ui/lab/Autocomplete";
import { ChallanOrdersDialog } from "./ChallanOrdersDialog.js";
import Moment from "moment";
import { extendMoment } from "moment-range";
import { GenerateChallanThermalMultiPDFAPI } from "../../config/api";
import { deliveryChallanTemplate } from "../../assets/html/deliveryChallanTemplate.js";
import { dataURItoBlob, htmlTemplateToDataString } from "../../utils/index.js";
import { toast } from "react-toastify";
const moment = extendMoment(Moment);

const filterOptions = createFilterOptions({
  matchFrom: "any",
  limit: 500,
});

const useStyles = makeStyles((theme) => ({
  fab: {
    marginTop: 26,
  },
  formControl: {
    paddingBottom: "10px",
    margin: "27px 0 0 0",
    position: "relative",
    verticalAlign: "unset",
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
}));

let columns = [
  { id: "codeR", label: "Code R" },
  { id: "codeL", label: "Code L" },
  { id: "nameR", label: "Name R" },
  { id: "nameL", label: "Name L" },
  { id: "quantity", label: "Quantity" },
  { id: "rateR", label: "Rate R" },
  { id: "rateL", label: "Rate L" },
  { id: "rate", label: "Rate" },
  {
    id: "discountAmount",
    label: "Discount Amount",
    format: (value) => {
      const numValue = Number(value);
      if (isNaN(numValue)) return value;
      return numValue.toLocaleString("en-IN", {
        maximumFractionDigits: 2,
        style: "currency",
        currency: "INR",
      });
    },
  },
  { id: "discountPercent", label: "Discount Percent" },
  { id: "fitting", label: "Fitting" },
  {
    id: "fittingAmount",
    label: "Fitting Amount",
    format: (value) => {
      const numValue = Number(value);
      if (isNaN(numValue)) return value;
      return numValue.toLocaleString("en-IN", {
        maximumFractionDigits: 2,
        style: "currency",
        currency: "INR",
      });
    },
  },
  { id: "tint", label: "Tint" },
  {
    id: "amount",
    label: "Amount",
    format: (value) => {
      const numValue = Number(value);
      if (isNaN(numValue)) return value;
      return numValue.toLocaleString("en-IN", {
        maximumFractionDigits: 2,
        style: "currency",
        currency: "INR",
      });
    },
  },
  { id: "orderRef", label: "Order Ref" },
  { id: "action", label: "Action" },
];

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
export default function ChallanDCDialog(props) {
  const classes = useStyles();
  const theme = useTheme();
  const { open, close, data, selectedRows } = props;
  let userInfo = useSelector((state) => state.userReducer.userInfo);
  let authToken = useSelector((state) => state.userReducer.authToken);

  const [percent, setPercent] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [entity, setEntity] = useState("");
  console.log("tityonen", entity)

  useEffect(() => {
    _getEntity();
  }, []);
  async function _getEntity() {
    try {
      let res = await axios.get(GetEntityAPI(userInfo.entity), {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      setEntity(res.data);
    } catch (err) {
      setEntity("");
      // toast.error(('Cannot fetch data'), {
      //   position: "top-center",
      //   autoClose: 1500,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "light",
      // });
    }
  }

  async function _onSave() {
    if (isSubmitting) return;
    if (selectedRows.length === 0) {
      toast.error("Please select a challan");
      return;
    }

    try {
      setIsSubmitting(true);
      const selectedChallans = selectedRows
        .map((id) => _.find(data, { _id: id }))
        .filter(Boolean);

      if (selectedChallans.length === 0) {
        toast.error("Selected challan(s) not found");
        return;
      }

      // Fetch print ads once
      let ad = "";
      try {
        const res = await axios.get(GetAllPrintAdsAPI(entity._id));
        const printAds = res.data.printAds || [];
        if (printAds.length > 0) {
          // Keep existing behavior: concatenate all titles
          printAds.forEach((p) => {
            ad = ad + (p.title || "") + " ";
          });
        }
      } catch (e) {
        // ignore ads fetch errors
      }

      const percentNum = Number(percent) || 0;
      const thermalDocs = [];

      // Build one render payload per challan, preserving each challan as a continuous block.
      for (let cIdx = 0; cIdx < selectedChallans.length; cIdx++) {
        const i = selectedChallans[cIdx];
        const party = i.party;
        const challanCode = i.code;
        const packagingCost = i.packagingCost || 0;

        const originalTotalAmount = (i.items || []).reduce(
          (acc, it) => acc + Number(it.amount || 0),
          0
        );

        const reductionRatio =
          originalTotalAmount > 0
            ? (originalTotalAmount - (originalTotalAmount * percentNum) / 100) / originalTotalAmount
            : 1;

        const reducedPackagingCost = packagingCost * reductionRatio;

        const reducedItems = (i.items || []).map((item) => {
          const quantity = Number(item.quantity || 0);
          const amount = Number(item.amount || 0);
          const reducedAmount = amount * reductionRatio;
          const reducedRate = quantity > 0 ? reducedAmount / quantity : 0;

          return {
            ...item,
            rate: reducedRate,
            amount: reducedAmount,
          };
        });

        thermalDocs.push({
          ad,
          clientAddress: party?.accountAddress ? party.accountAddress : "",
          clientName: party?.accountName || "",
          clientGSTNo: party?.gst || "",
          challanDate: moment().format("DD-MM-YYYY"),
          createdAt: moment(i.createdAt).format("DD-MM-YYYY"),
          items: reducedItems,
          challanCode,
          packagingCost: reducedPackagingCost,
          entityName: entity.name,
          entityId: entity._id,
          // No QR in this flow (thermal multi-print); can be added later if needed
          qr: false,
          qrCode: "",
        });
      }

      //   htmlData = {
      //     clientAddress: partyAddress,
      //     clientName: party.accountName,
      //     clientGSTNo: partyGstNumber,
      //     challanDate: moment().format("DD-MM-YYYY"),
      //     items: selectedItem.items,
      //     bank: res.data.banks[0],
      //     billCode: selectedItem.code,
      //     entityDetails: entity,
      //   };
      let options = {
        orientation: "p",
        unit: "pt",
        format: [850, 1066],
        // format:'letter',
        putOnlyUsedFonts: true,
        pagebreak: { mode: ['css', 'legacy'], before: "#pagebreak" },
      };
      console.log("tempdata (multi)", thermalDocs);

      // BEST: Generate on backend (Puppeteer) for stable thermal pagination.
      try {
        const resp = await axios.post(
          GenerateChallanThermalMultiPDFAPI(),
          {
            challanIds: selectedChallans.map((c) => c._id),
            entity: userInfo.entity,
            percent: Number(percent) || 0,
          },
          {
            headers: { Authorization: `Bearer ${authToken}` },
            responseType: "blob",
          }
        );

        const pdfBlob = resp.data;
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl);
      } catch (error) {
        console.error("Backend PDF generation failed:", error);
        toast.error("Backend print failed. Please try again or contact admin.");
      }

      close();
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <Dialog
      //   fullScreen
      open={open}
      onClose={close}
      TransitionComponent={Transition}
    >
      <GridContainer>
        <GridItem xs={12} sm={12}>
          <Card>
            <CardHeader color="primary">
              <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <Box>
                  <h4 className={classes.cardTitleWhite}>
                    Apply Discount to Challan
                  </h4>
                  <p className={classes.cardCategoryWhite}>
                    {selectedRows.length === 0
                      ? 'No challan selected'
                      : `${selectedRows.length} challan(s) selected`
                    }
                  </p>
                </Box>
                <Box
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"flex-end"}
                >
                  <Button style={{ color: "white" }} onClick={close}>
                    Close
                  </Button>
                </Box>
              </Box>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12}>
                  <CustomInput
                    labelText="Enter Discount Percentage (e.g., 10 for 10% off)"
                    id="percent"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: percent,
                      onChange: (e) => setPercent(e.target.value),
                      type: "number",
                      min: "0",
                      max: "100",
                      placeholder: "Enter percentage (0-100)"
                    }}
                  />
                  {selectedRows.length === 1 && data.find(item => item._id === selectedRows[0]) && (
                    <Box mt={2} p={2} style={{ backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                      <p><strong>Original Total:</strong> ₹{Number(data.find(item => item._id === selectedRows[0])?.amount || 0).toFixed(2)}</p>
                      {percent && !isNaN(percent) && percent > 0 && (
                        <p><strong>After {percent}% discount:</strong> ₹{(Number(data.find(item => item._id === selectedRows[0])?.amount || 0) * (1 - percent / 100)).toFixed(2)}</p>
                      )}
                    </Box>
                  )}
                </GridItem>
                <GridItem
                  xs={12}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={() => _onSave()}
                  // disabled={selectedRows.length !== 1 || !percent || isNaN(percent) || percent <= 0 || isSubmitting}
                  >
                    {isSubmitting ? "Generating…" : "Generate Discounted Receipt"}
                  </Button>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </Dialog>
  );
}
